import * as THREE from "three";

export const playForward = (animation) => {
  animation.reset();
  animation.clampWhenFinished = true;
  animation.timeScale = 1;
  animation.setLoop(THREE.LoopOnce, 1);
  animation.play();
};

export const playBackward = (animation) => {
  animation.timeScale = -1;
  animation.paused = false;
};
